import { render, staticRenderFns } from "./CustomerFileUpload.vue?vue&type=template&id=7530d731&scoped=true"
import script from "./CustomerFileUpload.vue?vue&type=script&lang=js"
export * from "./CustomerFileUpload.vue?vue&type=script&lang=js"
import style0 from "./CustomerFileUpload.vue?vue&type=style&index=0&id=7530d731&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7530d731",
  null
  
)

export default component.exports